const BASE_TAG = `<base target="_blank">`;

// Wraps rendered template HTML into a document for an iframe srcDoc. Links open in a new tab
// so clicking one in the preview doesn't navigate the iframe away from the listing.
export function buildTemplatePreviewDocument(html: string): string {
  const content = html ?? "";

  const headTag = /<head(\s[^>]*)?>/i;
  if (headTag.test(content)) {
    return content.replace(headTag, (head) => `${head}${BASE_TAG}`);
  }

  const htmlTag = /<html(\s[^>]*)?>/i;
  if (htmlTag.test(content)) {
    return content.replace(htmlTag, (open) => `${open}<head>${BASE_TAG}</head>`);
  }

  return `<!DOCTYPE html><html><head><meta charset="utf-8">${BASE_TAG}</head><body>${content}</body></html>`;
}
